import {
    Component,
    Input,
    OnInit,
    OnChanges,
    OnDestroy,
    SimpleChanges,
    Output,
    EventEmitter,
    ViewChild,
    ElementRef,
} from '@angular/core';
// import { FirebaseSna } from 'angularfire2';

import { AngularFireDatabase, AngularFireAction } from 'angularfire2/database';
import * as firebase from 'firebase/app';
// import 'firebase/auth';
import 'firebase/database';


import { AuthService } from '../auth/guard.service';

import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/first';

import { TagService } from '../tags/tag.service';

export enum SelectRequestDir {
    Next = 0,
    Previous,
}

export interface SelectRequest {
    currentIndex : number,
    direction : SelectRequestDir,
}

export interface IndexedSnap {
    index : number,
    snap : AngularFireAction<firebase.database.DataSnapshot>,
    select: Observable<void>,
}

export interface Item {
    date : string,
    text : string,
    timestamp: number,
}

/**
 * Part of the text. Type can be "tag" or "normal" for now.
 */
export interface Part {
    text : string,
    type : string,
}

@Component({
    selector: 'item',
    templateUrl: './Item.component.html',
    styleUrls: ['./Item.component.sass']
})
export class ItemComponent implements OnInit, OnChanges, OnDestroy {

    @Input() item : IndexedSnap
    private selectionSub : Subscription
    @Output() selectRequest = new EventEmitter<SelectRequest>();
    public text : string = "";

    public parts : Part[] = [];

    @ViewChild('itemInput') input : ElementRef;

    constructor(public tagService : TagService) {}

    contentChanged(newValue : string) {
        if (newValue.trim() != this.text.trim()) {
            // content changed
            this.text = newValue.trim();
            this.render();
            this.save();
        } else if (newValue.trim() != newValue) {
            // always dispaly trimmed text
            this.text = newValue.trim();
        }
    }

    render() {
        let tags = this.tagService.parse(this.text);
        let len = this.text.length;
        let parts : Part[] = [];
        var index = 0;

        for (let tag of tags) {
            if (index < tag.startPos) {
                parts.push({
                    text: this.text.substring(index, tag.startPos),
                    type: "normal",
                });
                index = tag.startPos;
            }
            if (index == tag.startPos) {
                parts.push({text : this.text.substring(index, tag.endPos), type: "tag"});
                index = tag.endPos;
            }
        }

        if (index != this.text.length) {
            parts.push({
                text: this.text.substr(index),
                type: "normal",
            })
        }

        this.parts = parts;

    }

    save() {
        let text = this.input.nativeElement.innerText.trim();
        this.item.snap.payload.ref.update({"text": text});
    }

    delete() {
        this.item.snap.payload.ref.remove();
    }

    onKeyDown(e : KeyboardEvent) {
        if (e.keyCode == 13) {
            // Enter key
            e.preventDefault();
            this.selectRequest.emit({currentIndex: this.item.index, direction: SelectRequestDir.Next});
        } else if (e.keyCode == 9) {
            // Tab key
            e.preventDefault();
            if (e.shiftKey) {
                this.selectRequest.emit({currentIndex: this.item.index, direction: SelectRequestDir.Previous});
            } else {
                this.selectRequest.emit({currentIndex: this.item.index, direction: SelectRequestDir.Next});
            }
        } else if (e.keyCode == 27){
            // Escape key
            e.preventDefault();
            let txt = this.item.snap.payload.val().text.trim();

            // reset the text to what it was before editing it
            this.text = txt;
            this.input.nativeElement.innerText = txt;

            // blur (deselect) the item
            this.input.nativeElement.blur();
            window.getSelection().removeAllRanges();
        }
    }

    ngOnInit() {
    }

    // thanks http://stackoverflow.com/a/4238971/555516
    placeCaretAtEnd() {
        let el = this.input.nativeElement;
        el.focus();
        if (typeof window.getSelection != "undefined"
                && typeof document.createRange != "undefined") {
            var range = document.createRange();
            range.selectNodeContents(el);
            range.collapse(false);
            var sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
        } else if (typeof (document.body as any).createTextRange != "undefined") {
            var textRange = (document.body as any).createTextRange();
            textRange.moveToElementText(el);
            textRange.collapse(false);
            textRange.select();
        }
    }

    ngOnChanges() {
        this.text = this.item.snap.payload.val().text.trim();
        this.render();

        if (this.selectionSub) {
            this.selectionSub.unsubscribe();
        }

        this.selectionSub = this.item.select.subscribe(() => {
            // select the article
            this.placeCaretAtEnd();
        })
    }

    ngOnDestroy() {
        if (this.selectionSub) {
            this.selectionSub.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// /Users/vlad/Projects/done/web/src/app/items/Item.component.ts